<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/post-approve')"
      >
        <span>Post Approve</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="
          $router.push({
            name: 'ViewDataPostApprove',
            query: { id: `${userID}` },
          })
        "
      >
        <span>ดูข้อมูล</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)</span>
      </v-flex>
    </v-layout>

    <!-- Start Form -->
    <v-card>
      <!-- <pre>
                {{form}}
            </pre> -->
      <!--            <v-layout pa-8 justify-center style="background-color: #3E7662;">-->
      <!--                <v-flex style="text-align: left;">-->
      <!--                    <span style="font-weight: bold;font-size: 28px;color: white;">แบบโครงร่างการวิจัย</span>-->
      <!--                </v-flex>-->
      <!--            </v-layout>-->

      <!--            <v-layout>-->
      <!--                <v-flex px-12 py-6>-->
      <!--                    &lt;!&ndash; 1. ชื่อโครงการ &ndash;&gt;-->
      <!--                    <v-layout>-->
      <!--                        <v-flex style="text-align: left;">-->
      <!--                            <span style="font-weight: bold;font-size: 16px;">1. ชื่อโครงการ</span>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4 mt-4>-->
      <!--                        <v-flex d-flex align-center justify-start>-->
      <!--                            <span style="font-weight: bold;font-size: 16px;color: #CC3D45;">*ภาษาไทย</span>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4>-->
      <!--                        <v-flex d-flex align-center>-->
      <!--                            <v-text-field-->
      <!--                                    dense-->
      <!--                                    hide-details-->
      <!--                                    readonly-->
      <!--                                    :model="form.thResearchName"-->
      <!--                            />-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4 mt-4>-->
      <!--                        <v-flex d-flex align-center justify-start>-->
      <!--                            <span style="font-weight: bold;font-size: 16px;color: #CC3D45;">*ภาษาอังกฤษ</span>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4>-->
      <!--                        <v-flex d-flex align-center>-->
      <!--                            <v-text-field-->
      <!--                                    dense-->
      <!--                                    hide-details-->
      <!--                                    readonly-->
      <!--                                    :model="form.thResearchName"-->
      <!--                            />-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->

      <!--                    &lt;!&ndash; 2. สาขาที่ทำการวิจัย&ndash;&gt;-->
      <!--                    <v-layout mt-6>-->
      <!--                        <v-flex style="text-align: left;">-->
      <!--                            <span style="font-weight: bold;font-size: 16px;">1. ชื่อโครงการ</span>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4 mt-4>-->
      <!--                        <v-flex d-flex align-center>-->
      <!--                            <v-text-field-->
      <!--                                    dense-->
      <!--                                    hide-details-->
      <!--                                    readonly-->
      <!--                                    :model="form.thResearchName"-->
      <!--                            />-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->

      <!--                    &lt;!&ndash; 3. ผู้วิจัยร่วมและที่ปรึกษา &ndash;&gt;-->
      <!--                    <v-layout mt-6>-->
      <!--                        <v-flex style="text-align: left;">-->
      <!--                            <span style="font-weight: bold;font-size: 16px;">3. ผู้วิจัยร่วมและที่ปรึกษา</span>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->
      <!--                    <v-layout pl-4 mt-4>-->
      <!--                        <v-flex>-->
      <!--                            <v-layout>-->
      <!--                                <v-flex mr-4 xs4 d-flex align-center justify-end>-->
      <!--                                    <span>ผู้ร่วมวิจัย</span>-->
      <!--                                </v-flex>-->
      <!--                                <v-flex xs8 d-flex align-center>-->
      <!--                                    <v-text-field-->
      <!--                                            dense-->
      <!--                                            hide-details-->
      <!--                                            readonly-->
      <!--                                            :model="form.thResearchName"-->
      <!--                                    />-->
      <!--                                </v-flex>-->
      <!--                            </v-layout>-->
      <!--                        </v-flex>-->
      <!--                        <v-flex>-->
      <!--                            <v-layout>-->
      <!--                                <v-flex mr-4 xs4 d-flex align-center justify-end>-->
      <!--                                    <span>ชื่อ-นามสกุล</span>-->
      <!--                                </v-flex>-->
      <!--                                <v-flex xs8 d-flex align-center>-->
      <!--                                    <v-text-field-->
      <!--                                            dense-->
      <!--                                            hide-details-->
      <!--                                            readonly-->
      <!--                                            :model="form.thResearchName"-->
      <!--                                    />-->
      <!--                                </v-flex>-->
      <!--                            </v-layout>-->
      <!--                        </v-flex>-->
      <!--                    </v-layout>-->

      <!--                </v-flex>-->
      <!--            </v-layout>-->
    </v-card>
    <!-- End Form -->

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../../components/table/FormTable";
import { mapState } from "vuex";
export default {
  components: {
    FormTable,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    userID: "",
    form: {
      // blog 1
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      // blog 2
      hasScreening: "1",
      screening: "",
      hasAdjustMethod: "1",
      adjustMethod: "",
      hasAddOperate: "1",
      addOperate: "",
      hasExpandTime: "1",
      expandTime: "",
      hasAdjustOtherMethod: "1",
      adjustOtherMethod: "",
      // blog 3
      hasInformationSheet: false,
      informationSheetVersion: "",
      informationSheetDate: "",
      hasProtocolModify: false,
      protocolModifyVersion: "",
      protocolModifyDate: "",
      inclusion: false,
      procedureChange: false,
      editorial: false,
      hasOtherChange: false,
      otherChange: "",
      hasInvestigator: false,
      investigatorVersion: "",
      investigatorDate: "",
      hasNewInformation: false,
      hasAdvertisement: false,
      hasChangeInTitle: false,
      changeInTitle: "",
      hasChangeInInvestigator: false,
      changeInInvestigatorAdd: "",
      changeInInvestigatorDelete: "",
      hasChangeInSponsor: false,
      changeInSponsorAdd: "",
      changeInSponsorDelete: "",
      signature: "",
      date: "",
      // blog 4
      researchName2: "",
      researcher: "",
      phoneNumber: "",
      affiliation: "",
      // blog 7
      researcherSignature: "",
      reportDate: "",
    },
    itemResearchAll: [],
    itemTableEdit: [],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //  if (this.user.currentRole !== 0) {
    //      this.$router.go(-1);
    // }
    this.getRF12(this.$route.query.id);
    this.userID = this.$route.query.userID;
  },
  methods: {
    getRF12(id) {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF12", id)
        .then((res) => {
          // console.log('res', res);
          this.form.researchCode = res.researchCode;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.researchName = res.researchName;
          this.form.hasScreening = res.hasScreening.toString();
          this.form.screening = res.screening;
          this.form.hasAdjustMethod = res.hasAdjustMethod.toString();
          this.form.adjustMethod = res.adjustMethod;
          this.form.hasAddOperate = res.hasAddOperate.toString();
          this.form.addOperate = res.addOperate;
          this.form.hasExpandTime = res.hasExpandTime.toString();
          this.form.expandTime = res.expandTime;
          this.form.hasAdjustOtherMethod = res.hasAdjustOtherMethod.toString();
          this.form.adjustOtherMethod = res.adjustOtherMethod;
          this.form.hasInformationSheet = res.hasInformationSheet.toString();
          this.form.informationSheetVersion = res.informationSheetVersion;
          this.form.informationSheetDate = res.informationSheetDate;
          this.form.hasProtocolModify = res.hasProtocolModify.toString();
          this.form.protocolModifyVersion = res.protocolModifyVersion;
          this.form.protocolModifyDate = res.protocolModifyDate;
          this.form.inclusion = res.inclusion.toString();
          this.form.procedureChange = res.procedureChange.toString();
          this.form.editorial = res.editorial.toString();
          this.form.hasOtherChange = res.hasOtherChange.toString();
          this.form.otherChange = res.otherChange;
          this.form.hasInvestigator = res.hasInvestigator.toString();
          this.form.investigatorVersion = res.investigatorVersion;
          this.form.investigatorDate = res.investigatorDate;
          this.form.hasNewInformation = res.hasNewInformation.toString();
          this.form.hasAdvertisement = res.hasAdvertisement.toString();
          this.form.hasChangeInTitle = res.hasChangeInTitle.toString();
          this.form.changeInTitle = res.changeInTitle;
          this.form.hasChangeInInvestigator = res.hasChangeInInvestigator.toString();
          this.form.changeInInvestigatorAdd = res.changeInInvestigatorAdd;
          this.form.changeInInvestigatorDelete = res.changeInInvestigatorDelete;
          this.form.hasChangeInSponsor = res.hasChangeInSponsor.toString();
          this.form.changeInSponsorAdd = res.changeInSponsorAdd;
          this.form.changeInSponsorDelete = res.changeInSponsorDelete;
          this.form.signature = res.signature;
          this.form.date = res.date;
          this.form.researchName2 = res.researchName2;
          this.form.researcher = res.researcher;
          this.form.phoneNumber = res.phoneNumber;
          this.form.affiliation = res.affiliation;
          this.form.researcherSignature = res.researcherSignature;
          this.form.reportDate = res.reportDate;
          if (res.research_amendment_edit) {
            res.research_amendment_edit.forEach((data) => {
              this.itemTableEdit.push({
                version: data.version,
                pageAndLine: data.pageAndLine,
                suggestion: data.suggestion,
              });
            });
          }
          if (res.research_amendment_information) {
            res.research_amendment_information.forEach((data) => {
              this.itemResearchAll.push({
                version: data.version,
                pageAndLine: data.pageAndLine,
                suggestion: data.suggestion,
              });
            });
          }
          this.isLoading = false;
        })
        .catch((e) => {
          console.log("error", 404);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
.v-sheet {
  border-radius: 0 !important;
}
</style>
